import { Button, Tooltip } from '@tecsinapse/cortex-react'
import React from 'react'
import { GoQuestion } from 'react-icons/go'
import { useSuperAdminForm } from '../hooks/use-form'
import { FormProvider, useFormState } from 'react-hook-form'
import FormSingleSelect from '../../hook-form-connectors/form-single-select'
import { FormTextField } from '../../hook-form-connectors/form-text-field'
import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { LinkExternoItem } from './link-externo'

export const Produto = () => {
  const { form, onSubmit, handleProdutoChange, produtos, fields } =
    useSuperAdminForm()
  const { handleSubmit } = form
  const { isValid, isDirty } = useFormState({ control: form.control })

  return (
    <FormProvider {...form}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={'flex flex-col gap-deca'}
      >
        <div className={'flex flex-1 flex-col items-center justify-start'}>
          <div className={'flex w-[100%] space-x-deca items-start'}>
            <FormSingleSelect
              name='produto'
              label='Produto'
              options={produtos.map(({ id, nome }) => ({
                value: id,
                label: nome
              }))}
              customOnChange={handleProdutoChange}
            />
            <div className='flex flex-col w-[100%] space-y-mili'>
              <FormTextField name='baseUriHomolog' label={t`URI Homolog`} />
              <FormTextField name='baseUri' label={t`URI Produção`} disabled />
            </div>
          </div>
        </div>

        <div className='flex flex-col w-full gap-mili mt-deca'>
          {fields.map((field, index) => (
            <LinkExternoItem
              key={field.id || index}
              link={field}
              index={index}
            />
          ))}
        </div>

        <div className={'flex flex-row items-center space-x-deca justify-end'}>
          <Button
            type={'submit'}
            disabled={!(isValid && isDirty)}
            variants={{
              className: 'w-[calc(50%-8px)] mt-deca'
            }}
          >
            <Trans>Atualizar</Trans>
          </Button>
          <Tooltip
            text={t`Para atualizar a URL de um produto, selecione o produto desejado e insira a URL do seu ambiente sem a '/' no final.`}
          >
            <GoQuestion
              className={'text-primary-medium hover:cursor-pointer'}
              size={24}
            />
          </Tooltip>
        </div>
      </form>
    </FormProvider>
  )
}
